import { hotmartCardPoliciesFallback } from '~/services/fetch/modules/fallback/hotmart-card-policies'

export function fallback({ slug, locale }) {
  if (!slug) throw new Error('slug param is required')
  if (!locale) throw new Error('locale param is required')

  const DEFAULT_VALUE = []
  const SLUG_TO_BE_IGNORED = [
    'co-creation-terms-of-use',
    'cookies-policy',
    'cyber-security-policy',
    'data-privacy-policy',
    'glossary',
    'payments-policy',
    'privacy-policy',
    'purchase-terms',
    'responsible-use-policy',
    'terms-of-use',
    'whatsapp-business',
  ]

  const RULE_SET = {
    ['hotmart-card-policies']: () => hotmartCardPoliciesFallback(locale),
  }

  if (SLUG_TO_BE_IGNORED.includes(slug) || ![...Object.keys(RULE_SET)].includes(slug)) return DEFAULT_VALUE

  return RULE_SET[slug]()
}
